export enum EActions {
	PERSIST = 'persist/PERSIST',
	REHYDRATE = 'persist/REHYDRATE',
	REGISTER = 'persist/REGISTER',
}

export enum EPaths {
	register = 'register',
	rehydrate = 'rehydrate',
}

export enum ESlice {
	root = 'root',
	auth = 'auth',
	trips = 'trips',
}
